import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { observer } from 'mobx-react-lite';

import { DefaultAppProps } from '../App';
import { HeightSlider } from './HeightSlider';
import { SoundButtons } from './SoundButtons';

import { ARIcon } from '@egr/xbox/egr-gui-icons/ARIcon';
import { FlexSpacer } from '@egr/xbox/egr-gui-elements/single-components/FlexSpacer';
import { iOSQuicklookArAvailable } from '@egr/xbox/utils/UserAgent';
import { BirdIcon } from '../layout/icons/Bird';
import { RestartIcon } from '../layout/icons/Restart';
import { HelpIcon } from '../layout/icons/Help';
import { BabyIcon } from '../layout/icons/Baby';
import { CameraPathButton } from './CameraPathButton';

export const HeaderBar: React.FC<DefaultAppProps> = observer(
    (props) => {
        const debugOpen: (event: React.MouseEvent) => Promise<void> = async (event) => {
            if (event.detail === 2 && event.shiftKey) {
                return props.app.startupActions._loadFile();
            }
        };

        const enterAr: () => void = () => props.app.viewManager.showARSize(true);
        const showGuide: () => void = () => props.app.viewManager.showGuide(true);

        const { arStarted, heightActiveButton } = props.app.viewManager.state;

        const disableNoneCameraPath: boolean = props.app.sceneManager.cameraPathInfo.playing === 'STARTED';

        return (
            <AppBar
                position="fixed"
                elevation={4}
                color="default"
                onClick={props.app.viewManager.setCanvcasFocus}
            >
                <Toolbar>
                    <img src="./img/logo.svg" style={{marginLeft: 5}} onClick={debugOpen}/>
                    <FlexSpacer />
                    <IconButton
                        color={heightActiveButton === 'child' ? 'primary' : undefined}
                        onClick={props.app.viewManager.setChildHeight}
                        disabled={disableNoneCameraPath}
                    >
                        <BabyIcon />
                    </IconButton>
                    <HeightSlider app={props.app} disabled={disableNoneCameraPath}/>
                    <IconButton
                        color={heightActiveButton === 'bird' ? 'primary' : undefined}
                        onClick={props.app.viewManager.setBirdHeight}
                        disabled={disableNoneCameraPath}
                    >
                        <BirdIcon />
                    </IconButton>
                    <Divider />
                    <IconButton
                        onClick={props.app.viewManager.animateToInitialCamera}
                        disabled={disableNoneCameraPath}
                    >
                        <RestartIcon />
                    </IconButton>
                    <CameraPathButton app={props.app}/>
                    <SoundButtons app={props.app}/>
                    <Divider/>
                    <IconButton
                        disabled={
                            !iOSQuicklookArAvailable ||
                            arStarted ||
                            disableNoneCameraPath
                        }
                        onClick={enterAr}
                    >
                        <ARIcon />
                    </IconButton>
                    <IconButton
                        edge="end"
                        onClick={showGuide}
                        disabled={disableNoneCameraPath}
                    >
                        <HelpIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
        );
    }
);

HeaderBar.displayName = 'HeaderBar';